export class AuthModel {
  constructor() { }

  public id: number;
  public username: string;
  public email: string;
  public fullname: string;
  public roleType: string;
  public token: string;
  public listResourceApi: string[];
  public hasPermission(url: string): boolean {
    const index = this.listResourceApi.findIndex((val, index) => {
      return val.toLowerCase() === url.toLowerCase();
    });
    return index > -1;
  }
}
export class ChangePasswordModel {
  constructor() { }
  public id: number;
  public username: string;
  public password: string;
  public newPassword: string;
  public repeatPassword: string;
}
